export default function maybeIPad(deviceInfo) {
  const touchDevice = typeof document !== "undefined" && "ontouchend" in document;
  return touchDevice && (deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.isMac);
}